export interface WorkerService {
  readonly id: number;
  readonly serviceName: string;
  readonly displayName: string;
  readonly oldAppName: string;
}

export const WorkerService = {
  CAISUKE: {
    id: 1,
    serviceName: "caisuke",
    displayName: "介護",
    oldAppName: "カイスケ"
  } as WorkerService,
  NURSUKE: {
    id: 2,
    serviceName: "nursuke",
    displayName: "看護",
    oldAppName: "ナースケ"
  } as WorkerService,
  PHARMACIST: {
    id: 3,
    serviceName: "pharmacist",
    displayName: "薬剤師",
    oldAppName: "カイテク薬剤師"
  } as WorkerService
} as const;

export const WORKER_SERVICES: WorkerService[] = Object.values(WorkerService);

export function getWorkerServiceById(id: number): WorkerService {
  const service = WORKER_SERVICES.find(service => service.id === id);
  if (!service) {
    throw new Error(`Invalid worker service id: ${id}`);
  }
  return service;
}

export const WORKER_SERVICE_ID_CHILDCARE = 4;
